// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Kpi$ReactHooksTemplate = require("./kpi.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var KpiCrud$ReactHooksTemplate = require("./KpiCrud.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var DomainModel$ReactHooksTemplate = require("./domainModel.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var UserKpiListHeader$ReactHooksTemplate = require("./UserKpiListHeader.res.js");

function reducer(state, action) {
  if (typeof action !== "object") {
    return {
            kpis: state.kpis,
            selectedKpi: state.selectedKpi,
            kpiChangeModalToggle: !state.kpiChangeModalToggle,
            action: state.action,
            outsideClick: state.outsideClick
          };
  }
  switch (action.TAG) {
    case "LoadKpis" :
        var kpis = action._0;
        if (kpis !== undefined) {
          return {
                  kpis: kpis,
                  selectedKpi: state.selectedKpi,
                  kpiChangeModalToggle: state.kpiChangeModalToggle,
                  action: state.action,
                  outsideClick: state.outsideClick
                };
        } else {
          return {
                  kpis: undefined,
                  selectedKpi: state.selectedKpi,
                  kpiChangeModalToggle: state.kpiChangeModalToggle,
                  action: state.action,
                  outsideClick: state.outsideClick
                };
        }
    case "SetKpi" :
        var kpi = action._0;
        if (kpi !== undefined) {
          return {
                  kpis: state.kpis,
                  selectedKpi: kpi,
                  kpiChangeModalToggle: state.kpiChangeModalToggle,
                  action: state.action,
                  outsideClick: state.outsideClick
                };
        } else {
          return {
                  kpis: state.kpis,
                  selectedKpi: undefined,
                  kpiChangeModalToggle: state.kpiChangeModalToggle,
                  action: state.action,
                  outsideClick: state.outsideClick
                };
        }
    case "SetAction" :
        return {
                kpis: state.kpis,
                selectedKpi: state.selectedKpi,
                kpiChangeModalToggle: state.kpiChangeModalToggle,
                action: action._0,
                outsideClick: state.outsideClick
              };
    case "SetKpiChangeModal" :
        return {
                kpis: state.kpis,
                selectedKpi: state.selectedKpi,
                kpiChangeModalToggle: action._0,
                action: state.action,
                outsideClick: state.outsideClick
              };
    case "SetOutsideClick" :
        return {
                kpis: state.kpis,
                selectedKpi: state.selectedKpi,
                kpiChangeModalToggle: state.kpiChangeModalToggle,
                action: state.action,
                outsideClick: action._0
              };
    
  }
}

var emptyPageInfo = {
  total: "1",
  perPage: "1",
  currentPage: "1"
};

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var initialState = {
  kpis: undefined,
  selectedKpi: undefined,
  kpiChangeModalToggle: false,
  action: "",
  outsideClick: true
};

function UserKpiManagement(props) {
  var match = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match[0];
  var match$1 = React.useReducer(reducer, initialState);
  var dispatch = match$1[1];
  var state = match$1[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var match$2 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$2[1];
  var pageInfo = match$2[0];
  var fetchUsers = function (param) {
    var pageNumber = pageInfo.currentPage;
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  var kpis = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("kpis", (function (param) {
                                            return Json_decode.list(Kpi$ReactHooksTemplate.decode, param);
                                          }), json));
                        }), param[1]);
                  return Promise.resolve([
                              kpis,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader("/api/v1/kpis?page=" + pageNumber));
  };
  var buildSurveyFormDict = function (kpi) {
    var params = {};
    params["user_id"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Kpi$ReactHooksTemplate.email(kpi));
    params["field"] = Kpi$ReactHooksTemplate.filterField(kpi);
    params["field_id"] = Kpi$ReactHooksTemplate.filterFieldId(kpi);
    params["value"] = Kpi$ReactHooksTemplate.filterValue(kpi);
    params["kpi"] = Kpi$ReactHooksTemplate.kpiValue(kpi);
    return params;
  };
  var buildTargetDict = function (kpi) {
    var params = {};
    params["field"] = Kpi$ReactHooksTemplate.filterField(kpi);
    params["field_id"] = Kpi$ReactHooksTemplate.filterFieldId(kpi);
    params["value"] = Kpi$ReactHooksTemplate.filterValue(kpi);
    params["kpi"] = Kpi$ReactHooksTemplate.kpiValue(kpi);
    return params;
  };
  var handlePageChange = function (pageNumber) {
    var pageNumber$1 = String(pageNumber);
    RescriptReactRouter.push("/users/all?page=" + pageNumber$1);
    Curry._1(setPageInfo, (function (pageInfo) {
            return {
                    total: pageInfo.total,
                    perPage: pageInfo.perPage,
                    currentPage: pageNumber$1
                  };
          }));
    window.scrollTo(0.0, 0.0);
  };
  var handleChange = function (kpi, action) {
    if (kpi === undefined) {
      return ;
    }
    switch (action) {
      case "create" :
          Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", Json_decode.string, response);
                  var kpi = Json_decode.field("kpi", Kpi$ReactHooksTemplate.decode, response);
                  if (status !== "success") {
                    return Promise.resolve((console.log("error"), undefined));
                  }
                  var kpis = state.kpis;
                  if (kpis !== undefined) {
                    return Promise.resolve((Curry._1(dispatch, {
                                      TAG: "LoadKpis",
                                      _0: List.append({
                                            hd: kpi,
                                            tl: /* [] */0
                                          }, kpis)
                                    }), Curry._1(dispatch, {
                                      TAG: "SetKpiChangeModal",
                                      _0: false
                                    })));
                  } else {
                    return Promise.resolve((Curry._1(dispatch, {
                                      TAG: "LoadKpis",
                                      _0: {
                                        hd: kpi,
                                        tl: /* [] */0
                                      }
                                    }), Curry._1(dispatch, {
                                      TAG: "SetKpiChangeModal",
                                      _0: false
                                    })));
                  }
                }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/kpis", buildSurveyFormDict(kpi)));
          return ;
      case "delete" :
          var kpiId = Kpi$ReactHooksTemplate.id(kpi);
          Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", Json_decode.string, response);
                  if (status !== "success") {
                    return Promise.resolve((console.log("error"), undefined));
                  }
                  var kpiId = Kpi$ReactHooksTemplate.id(kpi);
                  var kpis = state.kpis;
                  if (kpis !== undefined) {
                    return Promise.resolve((Curry._1(dispatch, {
                                      TAG: "LoadKpis",
                                      _0: Belt_List.keep(kpis, (function (x) {
                                              return Caml_obj.notequal(Kpi$ReactHooksTemplate.id(x), kpiId);
                                            }))
                                    }), Curry._1(dispatch, {
                                      TAG: "SetKpiChangeModal",
                                      _0: false
                                    })));
                  } else {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "SetKpiChangeModal",
                                    _0: false
                                  }));
                  }
                }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/kpis/" + String(Belt_Option.getWithDefault(kpiId, 0)) + "/delete", {}));
          return ;
      case "edit" :
          var kpiId$1 = Kpi$ReactHooksTemplate.id(kpi);
          Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", Json_decode.string, response);
                  if (status !== "success") {
                    return Promise.resolve((console.log("error"), undefined));
                  }
                  var kpiId = Kpi$ReactHooksTemplate.id(kpi);
                  var kpis = state.kpis;
                  if (kpis !== undefined) {
                    return Promise.resolve((Curry._1(dispatch, {
                                      TAG: "LoadKpis",
                                      _0: List.append({
                                            hd: kpi,
                                            tl: /* [] */0
                                          }, Belt_List.keep(kpis, (function (x) {
                                                  return Caml_obj.notequal(Kpi$ReactHooksTemplate.id(x), kpiId);
                                                })))
                                    }), Curry._1(dispatch, {
                                      TAG: "SetKpiChangeModal",
                                      _0: false
                                    })));
                  } else {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "SetKpiChangeModal",
                                    _0: false
                                  }));
                  }
                }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/kpis/" + String(Belt_Option.getExn(kpiId$1)) + "/update", buildTargetDict(kpi)));
          return ;
      default:
        console.log("Undefined Action");
        return ;
    }
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (param) {
                  var paginationInfo = param[1];
                  var perPage = paginationInfo[1];
                  var total = paginationInfo[0];
                  Curry._1(setPageInfo, (function (state) {
                          return {
                                  total: total,
                                  perPage: perPage,
                                  currentPage: state.currentPage
                                };
                        }));
                  return Promise.resolve(Js_promise.then_((function (xs) {
                                    return Promise.resolve(Curry._1(dispatch, {
                                                    TAG: "LoadKpis",
                                                    _0: xs
                                                  }));
                                  }), param[0]));
                }), fetchUsers());
        }), [pageInfo.currentPage]);
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  var page$1 = Belt_Int.fromString(pageInfo.currentPage);
  var paginationCurrentPage = page$1 !== undefined ? page$1 : currentPage;
  var tmp;
  if (Curry._1(hasPermission, "ShowKpi")) {
    var kpis = state.kpis;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("h2", {
                        children: "KPI Management",
                        className: "text-xl font-semibold"
                      }),
                  className: "flex items-center border-b border-gray-300 px-30-px py-16-px justify-between"
                }),
            JsxRuntime.jsx("div", {
                  children: Curry._1(hasPermission, "AddKpi") ? JsxRuntime.jsxs("button", {
                          children: [
                            JsxRuntime.jsx("img", {
                                  className: "h-14-px mr-2-px",
                                  src: Image$ReactHooksTemplate.plusCircle
                                }),
                            "New KPI"
                          ],
                          className: "bg-ghostwhite border border-gray-400\n            shadow-inner flex rounded py-2 px-3 text-xs focus:outline-none",
                          id: "add-campaign",
                          onClick: (function (param) {
                              Curry._1(dispatch, {
                                    TAG: "SetAction",
                                    _0: "create"
                                  });
                              Curry._1(dispatch, {
                                    TAG: "SetKpi",
                                    _0: undefined
                                  });
                              Curry._1(dispatch, "ToggleKpiChangeModal");
                            })
                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                  className: "flex justify-end px-30-px pt-20-px items-center"
                }),
            JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                  currentPage: paginationCurrentPage,
                  totalPages: totalPagesCount,
                  totalRecords: totalCount,
                  perPage: perPageCount,
                  handlePageChange: handlePageChange,
                  itemLabel: "KPIs",
                  className: "mx-30-px mb-4"
                }),
            kpis !== undefined ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("table", {
                          children: [
                            JsxRuntime.jsx(UserKpiListHeader$ReactHooksTemplate.make, {}),
                            JsxRuntime.jsx("tbody", {
                                  children: $$Array.of_list(List.map((function (kpi) {
                                              var selectedKpi = state.selectedKpi;
                                              return JsxRuntime.jsxs("tr", {
                                                          children: [
                                                            JsxRuntime.jsx("td", {
                                                                  children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Kpi$ReactHooksTemplate.email(kpi)),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: Kpi$ReactHooksTemplate.filterField(kpi),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: Kpi$ReactHooksTemplate.filterValue(kpi),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: String(Kpi$ReactHooksTemplate.kpiValue(kpi)),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "h-18-px",
                                                                                src: Image$ReactHooksTemplate.verticalDots,
                                                                                onClick: (function (param) {
                                                                                    Curry._1(dispatch, {
                                                                                          TAG: "SetOutsideClick",
                                                                                          _0: !state.outsideClick
                                                                                        });
                                                                                    Curry._1(dispatch, {
                                                                                          TAG: "SetKpi",
                                                                                          _0: kpi
                                                                                        });
                                                                                  })
                                                                              }),
                                                                          JsxRuntime.jsxs("div", {
                                                                                children: [
                                                                                  Curry._1(hasPermission, "UpdateKpi") ? JsxRuntime.jsxs("a", {
                                                                                          children: [
                                                                                            JsxRuntime.jsx("img", {
                                                                                                  className: "h-12-px",
                                                                                                  src: Image$ReactHooksTemplate.edit
                                                                                                }),
                                                                                            "Edit"
                                                                                          ],
                                                                                          className: "flex text-xs gap-2",
                                                                                          onClick: (function (param) {
                                                                                              Curry._1(dispatch, {
                                                                                                    TAG: "SetOutsideClick",
                                                                                                    _0: true
                                                                                                  });
                                                                                              Curry._1(dispatch, {
                                                                                                    TAG: "SetAction",
                                                                                                    _0: "edit"
                                                                                                  });
                                                                                              Curry._1(dispatch, "ToggleKpiChangeModal");
                                                                                            })
                                                                                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                                                                  Curry._1(hasPermission, "DeleteKpi") ? JsxRuntime.jsxs("a", {
                                                                                          children: [
                                                                                            JsxRuntime.jsx("img", {
                                                                                                  className: "h-12-px",
                                                                                                  src: Image$ReactHooksTemplate.trash
                                                                                                }),
                                                                                            "Delete"
                                                                                          ],
                                                                                          className: "flex text-xs gap-2",
                                                                                          href: "#",
                                                                                          onClick: (function (param) {
                                                                                              Curry._1(dispatch, {
                                                                                                    TAG: "SetOutsideClick",
                                                                                                    _0: true
                                                                                                  });
                                                                                              Curry._1(dispatch, {
                                                                                                    TAG: "SetAction",
                                                                                                    _0: "delete"
                                                                                                  });
                                                                                              Curry._1(dispatch, {
                                                                                                    TAG: "SetKpi",
                                                                                                    _0: kpi
                                                                                                  });
                                                                                              Curry._1(dispatch, "ToggleKpiChangeModal");
                                                                                            })
                                                                                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                                                ],
                                                                                className: "flex flex-col items-search p-2 absolute rounded border border-gray-400 bg-white\n                                          text-darkcharcoal text-xs question-dropdown z-50 opacity-100 gap-2 w-20 " + (
                                                                                  selectedKpi !== undefined && state.outsideClick === false && Caml_obj.equal(selectedKpi, kpi) ? "block" : "hidden"
                                                                                )
                                                                              })
                                                                        ],
                                                                        className: "flex justify-end items-center relative"
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                })
                                                          ],
                                                          className: "border-b border-bottom-gray-600"
                                                        });
                                            }), kpis))
                                })
                          ],
                          className: "text-left table-auto w-full border-separate text-sm font-medium"
                        }),
                    className: "flex px-30-px pb-30-px"
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                    children: Caml_option.some(JsxRuntime.jsx("p", {
                              children: "Fetching users..."
                            }))
                  }),
            state.kpiChangeModalToggle ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(KpiCrud$ReactHooksTemplate.make, {
                          handleChange: handleChange,
                          kpi: state.selectedKpi,
                          action: state.action,
                          toggleModal: (function (param) {
                              Curry._1(dispatch, "ToggleKpiChangeModal");
                            })
                        }),
                    className: "w-screen z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
                    style: {
                      height: "calc(100vh + 5rem)"
                    }
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
          ]
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsx("div", {
              children: tmp
            });
}

var make = UserKpiManagement;

exports.reducer = reducer;
exports.emptyPageInfo = emptyPageInfo;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.initialState = initialState;
exports.make = make;
/* react Not a pure module */
